let logger;
if (SERVER) {
  const { configureLogger } = require("@asosteam/asos-web-base-server");
  const { name } = require("../../../package.json");

  logger = configureLogger({
    moduleName: name,
    maxLogLevel: process.env.MAX_LOG_LEVEL
  });
} else {
  const {
    default: getLogLevelsDictionary
  } = require("./getLogLevelsDictionary");
  const { default: getLibLoggerForLevel } = require("./getLibLoggerForLevel");
  const { ALL_LOG_LEVELS } = require("./constants");
  const addLogFunctionsToObject = lib =>
    ALL_LOG_LEVELS.reduce((logger, level, index) => {
      logger[level] = getLibLoggerForLevel(level, index, lib);

      return logger;
    }, {});
  logger = addLogFunctionsToObject(console);
  logger.LOG_LEVELS_DICTIONARY = getLogLevelsDictionary();
}

export default logger;
